import { useMutation } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

/**
 * Announcement WRITES go through the API (which sends the native push). Reads
 * stay on Convex and update reactively once the API writes the rows, so these
 * mutations don't need manual query invalidation.
 */

export function useAnnouncementCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.announcement.create.mutationOptions())
}

export function useAnnouncementUpdate() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.announcement.update.mutationOptions())
}

export function useAnnouncementPublish() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.announcement.publish.mutationOptions())
}

export function useAnnouncementUnpublish() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.announcement.unpublish.mutationOptions())
}
